// GENERATED BY process-svg DO NOT EDIT
import { GeneratedIcon } from './Icon'
import { GeneratedIconProps } from './Icon/types'
// @ts-ignore
import Svg from './svg/icon-arrow.svg?react'

export const IconArrow = (props: GeneratedIconProps) => (
  <GeneratedIcon {...props}>
    <Svg preserveAspectRatio="xMidYMid meet" />
  </GeneratedIcon>
)

IconArrow.displayName = 'IconArrow'
